import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function CaseStudies() {
  return <section className="py-20 bg-white" data-id="element-25">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26">
        <div className="text-center mb-16" data-id="element-27">
          <span className="inline-block px-4 py-1 bg-[#F0F9F4] text-[#00A862] text-sm font-medium rounded-full mb-4 border border-[#00A862] shadow-sm" data-id="element-28">
            Success Stories
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-29">
            Real results from educational communities
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-30">
            See how schools and universities are transforming learning
            experiences with Nexio App
          </p>
        </div>
        <div className="bg-[#f8fafc] rounded-2xl overflow-hidden shadow-lg border-2 border-[#00A862]" data-id="element-31">
          <div className="md:flex" data-id="element-32">
            <div className="md:w-2/5 bg-[#F0F9F4] p-8 flex items-center border-4 border-[#00A862] rounded-lg shadow-md" data-id="element-33">
              <div data-id="element-34">
                <span className="inline-block px-3 py-1 bg-[#00A862] text-white text-sm font-medium rounded-full mb-4 shadow-sm" data-id="element-35">
                  Case Study
                </span>
                <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-36">
                  Riverside High School
                </h3>
                <p className="text-gray-700 mb-6" data-id="element-37">
                  How a 500-student high school transformed curriculum
                  development and doubled teacher collaboration
                </p>
                <div className="flex items-center text-[#00A862] font-medium" data-id="element-38">
                  <span data-id="element-39">Education Plan ($25/month)</span>
                </div>
              </div>
            </div>
            <div className="md:w-3/5 p-8 border-l-2 border-[#00A862] bg-white shadow-sm" data-id="element-40">
              <div className="mb-6 p-5 border-2 border-[#00A862] rounded-lg shadow-md hover:shadow-md transition-shadow bg-white" data-id="element-41">
                <h4 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-42">
                  The Challenge
                </h4>
                <ul className="space-y-2 text-gray-600" data-id="element-43">
                  <li data-id="element-44">
                    Lesson plans scattered across email and personal drives
                  </li>
                  <li data-id="element-45">
                    No structured way to share successful teaching strategies
                  </li>
                  <li data-id="element-46">Limited collaboration between departments</li>
                  <li data-id="element-47">
                    Difficulty tracking which resources were most effective
                  </li>
                </ul>
              </div>
              <div className="mb-6 p-5 border-2 border-[#00A862] rounded-lg shadow-md hover:shadow-md transition-shadow bg-white" data-id="element-48">
                <h4 className="text-lg font-semibold text-gray-900 mb-3" data-id="element-49">
                  Results After Implementation
                </h4>
                <ul className="space-y-2" data-id="element-50">
                  <li className="flex items-start" data-id="element-51">
                    <CheckIcon className="h-5 w-5 text-[#00A862] mr-2 flex-shrink-0" data-id="element-52" />
                    <span className="text-gray-600" data-id="element-53">
                      200+ lesson ideas shared, 75% adopted by other teachers
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-54">
                    <CheckIcon className="h-5 w-5 text-[#00A862] mr-2 flex-shrink-0" data-id="element-55" />
                    <span className="text-gray-600" data-id="element-56">
                      50% increase in cross-department collaboration
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-57">
                    <CheckIcon className="h-5 w-5 text-[#00A862] mr-2 flex-shrink-0" data-id="element-58" />
                    <span className="text-gray-600" data-id="element-59">
                      Teachers voted on curriculum improvements, leading to 25%
                      better student engagement
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-60">
                    <CheckIcon className="h-5 w-5 text-[#00A862] mr-2 flex-shrink-0" data-id="element-61" />
                    <span className="text-gray-600" data-id="element-62">
                      Saved 10+ hours per week of administrative coordination
                    </span>
                  </li>
                </ul>
              </div>
              <div className="italic text-gray-600 border-2 border-[#00A862] border-l-4 border-l-[#00A862] pl-4 p-5 rounded-lg shadow-md mb-6 bg-[#f9f9f9]" data-id="element-63">
                "Nexio transformed how our teachers collaborate. We have a
                living library of best practices, and our curriculum development
                process is now truly collaborative. It is not just a tool—it is
                how we build better education together."
                <div className="mt-2 font-medium not-italic" data-id="element-64">
                  — Dr. Emily Rodriguez, Principal at Riverside High School
                </div>
              </div>
              <Button variant="outline" className="flex items-center" data-id="element-65">
                Read full case study{' '}
                <ArrowRightIcon className="ml-2" size={16} data-id="element-66" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}